import { OrphanedEventActionTypes as types } from '../../actions'

    
   export default function orphanedevent(state={},action) {
        
        switch(action.type) {          
            case types.FETCH_ORPHANED_EVENTS: {           
                if(action.payload.data != undefined) {
                    const orphanedevents = action.payload.data
                    const recordsFound = action.payload.data.length > 0 ? true: false
                    return { ...state,
                            values:
                            {
                                ...state.values,
                                orphanedevents,
                                recordsFound,
                                searchCompleted:true
                            },
                            fields: {
                                ...state.fields,
                                orphanedevents,
                                recordsFound,
                                searchCompleted:true
                            }
                    }
                }
                return state
            }
            case types.FETCHING_EVENTS: { 
                const results = { searchCompleted: false }
                return { ...state,
                    values:
                    {
                        ...state.values,
                        ...results
                    },
                    fields: {
                        ...state.fields,
                        ...results
                    } 
                }
            }
          default: return state
        }
      } 


// WEBPACK FOOTER //
// ./src/redux/reducers/forms/orphanevent.js